/** Percent of the displayed daily calorie target, never a renormalized macro sum. */
export function macroEnergyPercentage(kcal: number, targetCalories: number): number {
  return Number.isFinite(kcal) && Number.isFinite(targetCalories) && targetCalories > 0
    ? kcal / targetCalories * 100 : 0;
}

export function macroEnergyGap(targetCalories: number, protein: number, carbs: number, fat: number): number {
  // Fibre and fat subtypes are separate targets, not additional macro allocations.
  return Math.round((targetCalories - (protein * 4 + carbs * 4 + fat * 9)) * 10) / 10;
}
